import { NameSpacing } from '../Common/Utils/NameSpacing'
import { LightDark } from './Types'

export const DETAILS = 'details'
export const PROVISIONING = 'provisioning'
export const DOMAINPROFILE = 'domainProfile'
export const CAPABILITIES = 'capabilities'
export const LICENSEMANAGEMENT = 'licenseManagement'
export const ADVANCED = 'advanced'
export const BRANDING: string = 'branding'
export const ESTATE: string = 'estate'
export const COLOUR: string = 'colours'
export const IMAGES: string = 'images'
export const LANGUAGES: string = 'languages'

export enum ProvisioningBroadworksServicePackEntryFieldNames {
    VALUE = 'Value',
    ENABLED = 'Enabled',
    ITEM_TYPE = 'ItemType',
    TELSYS_IDS = 'TelSysIDs',
    SEND_WELCOME_EMAIL = 'SendWelcomeEmail'
}

export enum DetailsTabFieldNames {
    DESCRIPTION = 'description',
    ID = 'id',
    BILLING_ID = 'billingid',
    PARENT_CME = 'parentcme',
    PROVIDER_IDS = 'providerids',
    DISABLE_AKIXI_LOGIN = 'disableAkixiLogin'
}

export enum DomainTabFieldNames {
    DOMAIN = 'domain',
    SERVER_IP_ADDRESS = 'serveripaddress',
    TCP_PORT = 'tcpport',
    COMMUNICATION_ACTIVE = 'communicationactive',
    FROM_ADDRESS_EMAIL = 'fromaddressemail',
    FROM_ADDRESS_NAME = 'fromaddressname',
    COMPANY_NAME = 'companyname',
    TEAMS_APP_DOWNLOAD_URL = 'teamsappdownloadurl',
    CXI_CLIENT_WINDOWS_URL = 'cxiClientWindowsUrl',
    CXI_CLIENT_MAC_URL = 'cxiClientMacUrl',
    SEARCH_AND_CALL_URL = 'searchAndCallUrl',
    USE_AUTHENTICATION = 'useauthentication',
    USERNAME = 'username',
    PASSWORD = 'password',
    CXI_ACCESS_CODE = 'cxiAccessCode'
}

export enum ServicepacksFieldNames {
    BROADWORKS = 'broadworks',
    SERVICE_PACKS = 'servicepacks'
}

export enum LicenseManagementFieldNames {
    ESSENTIALS = 'EssentialsCap',
    PROFESSIONAL = 'ProfessionalCap',
    ENTERPRISE = 'EnterpriseCap',
    CALL_CENTRE_AGENT = 'CallCentreAgentCap',
    CALL_CENTRE_SUPERVISOR = 'CallCentreSupervisorCap',
    CX_INTEGRATION = 'CXIntegrationCap'
}

export enum AdvancedTabFieldNames {
    RECURSIVE_BOTS_ENABLE = 'recursiveBotEnable'
}

export enum CapabilitiesFieldNames {
    CXA_BROADWORKS = 'cxaBroadworks',
    CXA_WEBEX = 'cxaWebex',
    CXA_TEAMS = 'cxaTeams',
    LEGACY_TELEPHONY = 'legacyTelephony',
    LEGACY = 'legacy',
    ENTERPRISE = 'enterprise',
    CXI_BROADWORKS = 'cxiBroadworks',
    CXI_TEAMS = 'cxiTeams',
    CXI_WEBEX = 'cxiWebex',
    CXS_BROADWORKS = 'cxsBroadworks',
    CXS_WEBEX = 'cxsWebex',
    CXS_TEAMS = 'cxsTeams',
    CXR_BROADWORKS = 'cxrBroadworks',
    CXR_WEBEX = 'cxrWebex',
    CXR_TEAMS = 'cxrTeams',
    AI_ASSIST = 'aiAssist',
    CXT_BROADWORKS = 'cxtBroadworks',
    CXT_WEBEX = 'cxtWebex',
    CXT_TEAMS = 'cxtTeams',
    MAX_TELSYS_COUNT = 'maxTelsysCount',
    SHOW_UI_VERSION_TOGGLE = 'showUiVersionToggle'
}

export enum BrandingFieldNames {
    brandingEnabled = 'brandingEnabled'
}

export const CMEDetailsNameSpacing = (fieldName: string): string => NameSpacing(DETAILS, fieldName)

export const PROVIDER_IDS_FIELD_NAME = CMEDetailsNameSpacing(DetailsTabFieldNames.PROVIDER_IDS)
export const DISABLE_AKIXI_LOGIN_FIELD_NAME = CMEDetailsNameSpacing(DetailsTabFieldNames.DISABLE_AKIXI_LOGIN)

export const CMEProvisioningNameSpacing = (fieldName: string): string => NameSpacing(PROVISIONING, fieldName)

export const CMEDomainNameSpacing = (fieldName: string): string => NameSpacing(DOMAINPROFILE, fieldName)

export const LicenceManagementNameSpacing = (fieldName: string): string => NameSpacing(LICENSEMANAGEMENT, fieldName)

export const CMECapabilitiesNameSpacing = (fieldName: string): string => NameSpacing(CAPABILITIES, fieldName)

export const getBrandingFieldName = (fieldName: string): string => NameSpacing(BRANDING, fieldName)

export const getColourFieldName = (fieldName?: string): Definable<LightDark> =>
    fieldName
        ? {
              light: getBrandingFieldName(fieldName),
              dark: getBrandingFieldName(`${fieldName}-darkmode`)
          }
        : undefined

export const getImageFieldName = (fieldName: string): string => getBrandingFieldName(fieldName)
export const getLanguagesFieldName = (fieldName: string): string => getBrandingFieldName(fieldName)

export const broadworksNameSpacing: string = NameSpacing(PROVISIONING, ServicepacksFieldNames.BROADWORKS)
export const servicepacksNameSpacing: string = NameSpacing(broadworksNameSpacing, ServicepacksFieldNames.SERVICE_PACKS)

export const CMEProvisioningBroadworksServicePackEntry = (index: number): string =>
    NameSpacing(servicepacksNameSpacing, index)

export const CMEProvisioningBroadworksServicePackEntryField = (fieldName: string, index: number): string =>
    NameSpacing(CMEProvisioningBroadworksServicePackEntry(index), fieldName)

export const PARENT_CME_FIELD_NAME: string = CMEDetailsNameSpacing(DetailsTabFieldNames.PARENT_CME)

export const RECURSIVE_BOTS_ENABLE_FIELD_NAME: string = CMEProvisioningNameSpacing(
    AdvancedTabFieldNames.RECURSIVE_BOTS_ENABLE
)

export const legacyFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.LEGACY)
export const enterpriseFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.ENTERPRISE)

export const cxaBroadworksFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.CXA_BROADWORKS)
export const cxaWebexFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.CXA_WEBEX)
export const cxaTeamsFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.CXA_TEAMS)

export const cxiBroadworksFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.CXI_BROADWORKS)
export const cxiTeamsFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.CXI_TEAMS)
export const cxiWebexFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.CXI_WEBEX)

export const cxsBroadworksFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.CXS_BROADWORKS)
export const cxsWebexFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.CXS_WEBEX)
export const cxsTeamsFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.CXS_TEAMS)
export const cxrBroadworksFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.CXR_BROADWORKS)
export const cxrWebexFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.CXR_WEBEX)
export const cxrTeamsFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.CXR_TEAMS)
export const aiAssistFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.AI_ASSIST)
export const cxtBroadworksFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.CXT_BROADWORKS)
export const cxtWebexFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.CXT_WEBEX)
export const cxtTeamsFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.CXT_TEAMS)

export const legacyTelephonyFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.LEGACY_TELEPHONY)
export const maxTelsysCountFieldName: string = CMECapabilitiesNameSpacing(CapabilitiesFieldNames.MAX_TELSYS_COUNT)
export const showUiVersionToggleFieldName: string = CMECapabilitiesNameSpacing(
    CapabilitiesFieldNames.SHOW_UI_VERSION_TOGGLE
)

// Licence management field names
export const ESSENTIALS_LICENCE_FIELD_NAME: string = LicenceManagementNameSpacing(
    LicenseManagementFieldNames.ESSENTIALS
)
export const PROFESSIONAL_LICENCE_FIELD_NAME: string = LicenceManagementNameSpacing(
    LicenseManagementFieldNames.PROFESSIONAL
)
export const ENTERPRISE_LICENCE_FIELD_NAME: string = LicenceManagementNameSpacing(
    LicenseManagementFieldNames.ENTERPRISE
)
export const CALL_CENTRE_AGENT_LICENCE_FIELD_NAME: string = LicenceManagementNameSpacing(
    LicenseManagementFieldNames.CALL_CENTRE_AGENT
)
export const CALL_CENTRE_SUPERVISOR_LICENCE_FIELD_NAME: string = LicenceManagementNameSpacing(
    LicenseManagementFieldNames.CALL_CENTRE_SUPERVISOR
)

// Branding field names
export const BRANDING_ENABLED_FIELD_NAME: string = getBrandingFieldName(BrandingFieldNames.brandingEnabled)

// Domain profile field names
export const TEAMS_APP_DOWNLOAD_URL_FIELD_NAME: string = CMEDomainNameSpacing(
    DomainTabFieldNames.TEAMS_APP_DOWNLOAD_URL
)
export const CXI_CLIENT_WINDOWS_URL_FIELD_NAME: string = CMEDomainNameSpacing(
    DomainTabFieldNames.CXI_CLIENT_WINDOWS_URL
)
export const CXI_CLIENT_MAC_URL_FIELD_NAME: string = CMEDomainNameSpacing(DomainTabFieldNames.CXI_CLIENT_MAC_URL)
export const SEARCH_AND_CALL_URL_FIELD_NAME: string = CMEDomainNameSpacing(DomainTabFieldNames.SEARCH_AND_CALL_URL)
